
export const levels = {
    easy: [
        {
            n: "e1",
            g: [[1,1,1,2],[0,1,1,2],[0,0,0,2],[3,3,2,2]],
            b: [[3,6], [-1,8], [-6,6], [0,3]],
        },
        {
            n: "e2",
            g: [[0,1,1,1,1],[0,1,0,0,1],[0,1,1,0,1],[0,0,0,0,1],[1,1,1,1,1]],
            b: [[3,8], [-2,7]]
        },
        {
            n: "e3",
            g: [[0,0,2,2,2,3],[0,0,2,1,2,3],[1,0,2,1,2,3],[1,1,1,1,2,3]],
            b: [[0,7], [3,6], [5,6], [-7,6]],
        },
        {
            n: "e4",
            g: [[0,1,2,2,2],[0,1,1,2,2],[0,0,1,2,2]],
            b: [[5,5], [-3,5], [-1,5]],
        },
        {
            n: "e5",
            g: [[0,1,1,1,3],[0,0,0,1,3],[2,2,0,1,3],[2,2,0,3,3]],
            b: [[5,6], [1,7], [-1,5], [-3,6]],
        },
        {
            n: "e6",
            g: [[3,3,1,1],[3,0,0,1],[3,2,0,0],[3,2,2,2]],
            b: [[-1,5], [3,7], [-4,5], [3,6]],
        },
        { //extremely easy
            n: "e7",
            g: [[0,2,2],[0,2,1],[0,1,1]],
            b: [[1,5], [-3,5], [2,6], [0,0]],
        },
        {
            n: "e8",
            g: [[0,3,3,3,3],[0,0,0,0,1],[2,2,2,2,1],[2,2,2,1,1]],
            b: [[1,7], [1,6], [-3, 5], [-2,6]],
        },
        { //very easy
            n: "e9",
            g: [[0,0,0,1,2],[1,1,0,1,2],[2,1,1,1,2],[2,2,2,2,2]],
            b: [[1,7], [-3,6], [2,6]],
        },
        {
            n: "e10",
            g: [[2,2,0,0],[1,2,0,3],[1,2,2,3],[1,1,3,3]],
            b: [[1,7], [0,5], [1,7], [-4,5]],
        },
        {
            n: "e11",
            g: [[0,0,0,1,1,1],[3,3,0,0,1,1],[3,3,2,2,1,1],[3,3,2,2,1,1]],
            b: [[7,7], [-8,6], [-2,5], [4,5]],
        },
        {
            n: "e12",
            g: [[0,0,0,0,0],[2,2,2,1,0],[3,3,2,1,1],[3,3,2,1,1]],
            b: [[7,7], [-3,5], [3,5], [-4,5]],
        },
        {
            n: "e13",
            g: [[0,0,3,3],[0,1,3,3],[0,1,2,2],[1,1,2,2]],
            b: [[-3,6], [-1,6], [3,5], [0,6]],
        },
        { //very EASY
            n: "e14",
            g: [[0,0,0,1,2,2],[0,0,0,1,2,2],[1,0,0,1,2,2],[1,0,0,1,2,2],[1,1,1,1,2,2]],
            b: [[-2,8], [5,7], [-2,7]],
        },
        { //very EASY
            n: "e15",
            g: [[0,0,1,2],[1,0,1,2],[1,0,1,2],[1,1,1,2]],
            b: [[-3,6], [4,6], [-2,6]],
        },
        {
            n: "e16",
            g: [[0,0,0,3,3],[0,0,3,3,3],[0,3,3,2,3],[1,1,3,2,2],[1,1,1,2,2]],
            b: [[3,8], [1,7], [-5,7], [-2,7]],
        },    
        { //very EASY!
            n: "e17",
            g: [[0,2,2,2,2],[0,0,1,2,2],[0,0,1,1,1]],
            b: [[4,5], [-2,5], [-6,6]],
        },
        { //EASY!
            n: "e18",
            g: [[0,0,1,2,2],[0,0,1,1,2],[0,0,1,2,2]],
            b: [[-1,5], [3,5], [-1,5]],
        },
        { //Very easy, nice shape!
            n: "e19",
            g: [[0,1,2,3,4],[0,1,2,3,4],[0,1,2,3,4]],
            b: [[2,5], [-1,5], [2,5], [-5,5], [2,5]],
        },
        {
            n: "e20",
            g: [[0,0,0,0,3,3],[1,2,2,2,3,3],[1,1,1,2,3,3]],
            b: [[3,5], [2,4], [-4,4], [-4,5]],
        },
        {
            n: "e21",
            g: [[0,0,0,0,1,3],[2,1,1,1,1,3],[2,1,3,3,3,3],[2,2,2,2,3,3]],
            b: [[3,7], [-4,6], [1,5], [4,6]],
        },
        {
            n: "e22",
            g: [[0,1,1,1,2],[0,1,0,0,2],[0,1,0,0,2],[0,0,0,2,2]],
            b: [[-2,6], [1,7], [1,6]],
        },
        { //easyish - nice level for tutorial
            n: "e23",
            g: [[0,1,2,2,2,3],[0,1,2,1,2,3],[0,1,1,1,2,3],[0,0,0,0,2,3]],
            b: [[-1,6], [4,7], [-1,6], [-1,6]],
        },
        { //VERY easy but nice shape-> tutorial
            n: "e24",
            g: [[0,3,3,3,3,3],[0,2,2,2,2,2],[0,0,0,0,0,0],[1,1,1,1,1,0]],
            b: [[4,6], [-5,3], [-4,6], [-2,8]],
        },
        { //easy
            n: "e25",
             g: [[0,0,0,2,2],[1,0,2,2,2],[1,1,1,1,2]],
             b: [[1,6], [-3,4], [2,5]],
        },
        { //easy
            n: "e26",
             g: [[0,0,0,2,2],[0,1,1,2,2],[0,1,2,2,2],[0,1,2,2,2],[1,1,1,2,2]],
             b: [[-2,8], [3,6], [-2,7]],
        },
        {
            n: "e27",
            g: [[0,1,1,1,1],[0,2,2,2,3],[0,0,2,3,3]],
            b: [[5,5], [0,7], [0,4], [-4,5]]
        },

        {//easy level -> could be tutorial!!!
            n: "e28",
            g: [[1,1,1,1,0],[1,1,1,0,0],[1,1,0,0,0],[1,0,0,0,0]],
            b: [[-3,6], [3,6]]
        },

        {   //very easy -> tutorial
            n: "e29",
            g: [[1,1,2,0],[1,2,2,0],[1,0,0,0]],
            b: [[-5,5], [0,5], [3,5]]
        },
    ],





    normal: [
        {
            n: "n1",
            g: [[1,1,1,2,4],[1,1,2,2,4],[1,3,3,3,4],[0,0,0,0,4]],
            b: [[-2,4], [5,6], [1,6], [0,4], [-7,6]]
        },
        {
            n: "n2",
            g: [[0,0,0,1,1],[3,3,0,0,1],[3,2,2,2,1],[3,3,2,1,1]],
            b: [[-1,8], [1,6], [-3,4], [2,5]],
        },    
        { //Medium
            n: "n3",
            g: [[0,0,0,2,2],[0,0,1,1,2],[1,1,1,2,2],[3,3,3,3,3]],
            b: [[0,7], [3,5], [-5,6], [0,3]],
        },
        {
            n: "n4",
            g: [[3,3,2,0,0],[3,2,2,0,0],[3,2,1,0,0],[3,2,1,1,1]],
            b: [[-1,6], [-2,6], [3,6], [-1,6]],
        },
        {
            n: "n5",
            g: [[0,0,0,4,4,4],[3,1,0,4,1,4],[3,1,1,1,1,2],[3,3,3,2,2,2]],
            b: [[5,7], [-1,7], [-2,4], [4,5], [-5,6]],
        },
        {
            n: "n6",
            g: [[0,0,0,0,0],[0,3,4,4,5],[1,3,3,4,5],[1,3,3,4,5],[1,1,5,5,5]],
            b: [[-2,10], [3,5], [0,0], [-1,6], [-5,6], [1,6]],
        },
        {
            n: "n7",
            g: [[0,0,0,0,0,1],[4,0,3,1,1,1],[4,3,3,3,2,2],[4,4,4,2,2,2]],
            b: [[1,6], [-2,7], [-5,5], [4,6], [4,6], [0,0]],
        },
        {
            n: "n9",
            g: [[0,1,1,1,1],[0,0,0,2,1],[3,3,0,2,1],[3,2,2,2,2],[3,3,3,3,2]],
            b: [[3,8], [2,7], [-4,6], [1,7]],
        },
        {
            n: "n10",
            g: [[0,1,1,1,1],[0,0,3,3,1],[2,3,3,3,3],[2,2,2,2,3]],
            b: [[2,8], [0,6], [3,5], [-3,5]]
        },
        {
            n: "n11",
            g: [[0,0,3,3,3],[2,0,0,3,1],[2,2,0,1,1],[2,2,2,1,1]],
            b: [[0,7], [3,5], [3,5], [-4,8]],
        },
        {
            n: "n12",
            g: [[0,1,1,2],[0,1,2,2],[0,1,1,2],[3,1,2,3],[3,3,3,3]],
            b: [[3,8], [-3,7], [2,7], [-1,7]],
        },
        {
            n: "n13",
            g: [[0,1,1,2,3],[0,1,2,2,3],[0,1,2,2,3],[0,1,4,4,3],[0,0,4,4,3]],
            b: [[3,7], [-1,8], [-4,8], [1,7], [-1,6]],
        },

        { //maybe this is already hard
            n: "n14",
            g: [[0,4,4,4,4],[0,0,0,3,4],[1,1,0,3,3],[1,1,1,3,2],[1,2,2,2,2]],
            b: [[4,9], [3,5], [-2,4], [-6,6], [-2,9]],
        },
        { //between normal and hard!
            n: "n15",
            g: [[0,0,1,1,2,2],[0,0,0,1,2,2],[1,1,1,1,3,3],[3,3,3,3,3,3],[3,3,4,4,4,4]],
            b: [[3,7], [5,8], [-7,7], [-3,6], [-2,6]],
        },
        { //FUN shape!
            n: "n16",
            g: [[0,0,0,3,3,3],[0,0,1,0,3,3],[1,1,2,3,2,2],[1,1,1,2,2,2]],
            b: [[-3,8], [5,5], [-1,6], [-3,6]],
        },
        {
            n: "n17",
             g: [[0,0,0,2,2,2],[0,1,0,2,3,3],[0,1,0,3,3,3],[1,1,1,1,1,1],[4,4,4,4,4,4]],
             b: [[5,8], [-2,7], [-3,8], [-1,7], [0,3]],
        },
        {
            n: "n18",
             g: [[0,0,0,2,3,3],[0,1,1,2,3,3],[0,1,1,2,2,2],[0,1,1,1,1,1]],
             b: [[-1,6], [2,5], [-1,7], [-4,7]],
        },
        {
            n: "n19",
             g: [[0,0,0,0,2,3],[0,1,2,2,2,3],[0,1,2,2,2,3],[1,1,1,1,2,3],[3,3,3,3,3,3]],
             b: [[2,7], [0,7], [-5,7], [1,7]],
        },
        {
            n: "n20",
            g: [
                [0,0,0,1,1,2],[3,0,0,4,1,2],[3,3,0,4,1,2],[3,3,4,4,4,2],],
            b: [[-2,6], [-1,6], [-4,6], [5,5], [1,6]],
        },
        {
            n: "n21",
            g: [[0,0,0,0,3],[0,1,1,0,3],[0,1,2,3,3],[1,1,2,2,2]],
            b: [[0,6], [3,5], [-5,4], [2,6]],
        }, 
        {
            n: "n22",
            g: [
                [0,1,1,1,1,3],[0,0,1,1,3,3],[0,0,2,2,3,3],[0,2,2,2,2,2]],
            b: [[4,6], [5,7], [-5,5], [-3,6]]
        },
        {
            n: "n23",
            g: [[0,0,3,3,3],[0,0,1,1,3],[1,0,1,2,2],[1,1,1,2,2]],
            b: [[5,6], [1,6], [-6,4], [-3,6]]
        },
        
    ],





    hard: [
        { //could be also normal
            n: "h1",
            g: [[0,0,3,3,3,3],[0,0,3,4,3,3],[0,0,4,4,4,3],[0,1,1,4,2,3],[0,0,1,2,2,2],[1,1,1,2,2,2]],
            b: [[2,9], [5,7], [-5,7], [-9,10], [6,7]],
        },
        {
            n: "h2",
            g: [[0,0,0,0,0,4],[2,2,2,1,0,4],[2,3,3,1,0,4],[2,2,3,1,1,4],[3,3,3,4,4,4]],
            b: [[3,7], [-4,6], [2,7], [4,6], [-4,7]],
        },
        {
            n: "h3",
            g: [[0,0,0,0,0,3],[3,3,3,3,0,3],[1,1,4,3,3,3],[1,1,4,4,4,4],[5,5,5,5,5,5],[2,2,2,2,2,2]],
            b: [[2,9], [-1,7], [8,5], [-1,11], [-8,8], [6,8]],
        },
        { //hard?
            n: "h4",
            g: [[0,0,0,0,1,1],[0,3,0,0,0,1],[3,3,2,2,2,1],[3,3,2,4,2,1],[3,2,2,4,4,4],[3,3,3,3,4,4]],
            b: [[3,12], [-6,9], [-2,9], [7,7], [-1,6]],
        },
        {
            n: "h5",
            g: [[0,0,0,0,0,4],[0,0,1,2,2,4],[1,1,1,1,2,4],[3,2,1,2,2,4],[3,2,2,2,2,4],[3,3,3,3,4,4]],
            b: [[1,12], [4,9], [-4,9], [1,5], [3,8], [0,0]],
        },
        { //very hard?
            n: "h6",
            g: [[0,0,5,4,4,4],[0,0,5,4,4,3],[0,0,5,5,5,3],[0,1,5,5,5,3],[0,1,1,2,2,3],[1,1,2,2,2,3]],
            b: [[3,8], [0,5], [-3,8], [-6,7], [-7,9], [3,10]],
        },
        {
            n: "h7",
            g: [[0,1,1,1,1,1],[0,0,0,0,4,4],[2,2,2,3,3,4],[2,2,3,3,3,4],[2,3,3,3,4,4]],
            b: [[-2,10], [4,8], [3,5], [1,7], [-3,6]],
        },
        {
            n: "h8",
            g: [[0,0,0,2,3,3],[1,0,0,2,3,3],[1,1,1,2,3,3],[1,4,2,2,2,3],[4,4,4,4,4,3]],
            b: [[3,10], [2,6], [-2,7], [1,7], [-2,7]],
        },
        {
            n: "h9",
            g: [[0,1,1,1,1,1],[0,1,2,2,1,3],[0,0,2,2,3,3],[4,4,4,2,2,3],[4,4,4,2,2,3]],
            b: [[6,9], [-3,10], [0,7], [0,6], [-1,4]],
        },
    ],
};

const testLevels = [
    {
        n: "5x5",
        g: [
                    [0,0,0,0,0],
                    [0,0,0,0,0],
                    [0,0,0,0,0],
                    [0,0,0,0,0],
                    [0,0,0,0,0],
                ],
                b: [[0,7]]
    },
    {
        n: "5x4",
        g: [
                    [0,0,0,0,0],
                    [0,0,0,0,0],
                    [0,0,0,0,0],
                    [0,0,0,0,0],
                ],
                b: [[0,6]]
    },
    {
        n: "5x3",

        g: [
                    [0,0,0,0,0],
                    [0,0,0,0,0],
                    [0,0,0,0,0],
                ],
                b: [[0,5]]
    },
    {
        n: "4x4",
        g: [
                    [0,0,0,0],
                    [0,0,0,0],
                    [0,0,0,0],
                    [0,0,0,0],
                ],
                b: [[0,6]]
    },
    {
        n: "4x3",
        g: [
                    [0,0,0,0],
                    [0,0,0,0],
                    [0,0,0,0],
                ],
                b: [[0,5]]
    },
   
    {
        n: "3x3",
        g: [
                    [0,0,0],
                    [0,0,0],
                    [0,0,0],
                ],
                b: [[0,5]]
    },
    {
        n: "6x6",
        g: [
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],   
            ],
                b: [[0,8]]
    },
    
    {
        n: "6x4",
        g: [
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
            ],
                b: [[0,6]]
    },
    {
        n: "6x5",
        g: [
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
                [0,0,0,0,0,0],
            ],
                b: [[0,7]]
    },
]